import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import type { AdItem } from '@sbt-web/network/types';
import { ItemPicture, ItemPrice } from '@sbt-web/ui';
import { isShippable } from '@sbt-web/utils';
import { useTrackImpression } from '@/tools/tracking/useTrackImpression';
import cssClass from './index.module.scss';
type CardProps = {
  item: AdItem;
  onClick?: () => void;
  onImpression?: () => void;
};
export const Card = function (t0) {
  const $ = _c(27);
  const {
    item,
    onClick,
    onImpression
  } = t0;
  const componentRef = useRef(null);
  let t1;
  if ($[0] !== onImpression) {
    t1 = {
      enabled: true,
      track: () => {
        onImpression?.();
      }
    };
    $[0] = onImpression;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setComponentRef = useTrackImpression(t1);
  let t2;
  let t3;
  if ($[2] !== setComponentRef) {
    t2 = () => {
      if (componentRef?.current) {
        setComponentRef(componentRef.current);
      }
    };
    t3 = [setComponentRef, componentRef];
    $[2] = setComponentRef;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== item) {
    t4 = isShippable(item);
    $[5] = item;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const isShippableAd = t4;
  const t5 = `${item.urls.default}`;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["160x120", "108x82"];
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== item.category.id || $[9] !== item.images) {
    t7 = <div className={cssClass.card__image}><ItemPicture className={cssClass.card__image__picture} images={item.images} categoryID={item.category.id} formats={t6} subject="" /></div>;
    $[8] = item.category.id;
    $[9] = item.images;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== item.subject) {
    t8 = <h4 className={`headline-6 ${cssClass.card__title}`}>{item.subject}</h4>;
    $[11] = item.subject;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = item.geo?.town?.value ?? "";
  const t10 = item.geo?.city?.shortName ? `(${item.geo.city.shortName})` : "";
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <span className={`caption small ${cssClass.card__place}`}>{t9}{" "}{t10}</span>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== isShippableAd || $[17] !== item.features || $[18] !== item.type) {
    t12 = item.features["/price"] && <ItemPrice adType={item.type.key} classes={[cssClass.card__price]} price={Number(item.features["/price"].values[0].key)} badgeConfiguration={{
      display: "card",
      shippable: isShippableAd
    }} />;
    $[16] = isShippableAd;
    $[17] = item.features;
    $[18] = item.type;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== onClick || $[21] !== t11 || $[22] !== t12 || $[23] !== t5 || $[24] !== t7 || $[25] !== t8) {
    t13 = <a href={t5} className={cssClass.card} onClick={onClick} ref={componentRef}>{t7}{t8}{t11}{t12}</a>;
    $[20] = onClick;
    $[21] = t11;
    $[22] = t12;
    $[23] = t5;
    $[24] = t7;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};